export default class TeachersActions {
  // namespace actions adoptions
  static TEACHERS_FETCH_REQUEST = 'TEACHERS_FETCH_REQUEST'
  static TEACHERS_FETCH_SUCCESS = 'TEACHERS_FETCH_SUCCESS'
  static TEACHERS_FETCH_ERROR = 'TEACHERS_FETCH_ERROR'
  // namespace actions confirm teacher account
  static CONFIRM_TEACHER_ACCOUNT_REQUEST = 'CONFIRM_TEACHER_ACCOUNT_REQUEST'
  static CONFIRM_TEACHER_ACCOUNT_SUCCESS = 'CONFIRM_TEACHER_ACCOUNT_SUCCESS'
  static CONFIRM_TEACHER_ACCOUNT_ERROR = 'CONFIRM_TEACHER_ACCOUNT_ERROR'

  // actions teachers account
  static fetchTeachersRequest () {
    return {
      type: TeachersActions.TEACHERS_FETCH_REQUEST
    }
  }
  static fetchTeachersSuccess (payload) {
    return {
      type: TeachersActions.TEACHERS_FETCH_SUCCESS,
      payload
    }
  }
  static fetchTeachersError (payload) {
    return {
      type: TeachersActions.TEACHERS_FETCH_ERROR,
      payload
    }
  }

  // actions confirm teacher account
  static confirmTeacherAccountRequest () {
    return {
      type: TeachersActions.CONFIRM_TEACHER_ACCOUNT_REQUEST
    }
  }
  static confirmTeacherAccountSuccess (payload) {
    return {
      type: TeachersActions.CONFIRM_TEACHER_ACCOUNT_SUCCESS,
      payload
    }
  }
  static confirmTeacherAccountError (payload) {
    return {
      type: TeachersActions.CONFIRM_TEACHER_ACCOUNT_ERROR,
      payload
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/teachers/actions.js